import './loading.scss';

const Loading = ({
  message = 'Loading...',
  type = 'spinner',
  inline = false,
}) => {
  // For inline loading (used on pages with existing content)
  if (inline) {
    return (
      <div className="loading-inline">
        <div className="loading-inline-content">
          {type === 'spinner' && (
            <div className="inline-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-center"></div>
            </div>
          )}

          {type === 'dots' && (
            <div className="inline-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          )}

          {type === 'pulse' && (
            <div className="inline-pulse">
              <div className="pulse-circle"></div>
              <div className="pulse-wave"></div>
              <div className="pulse-wave"></div>
            </div>
          )}

          <p className="inline-text">{message}</p>
        </div>
      </div>
    );
  }

  // For full-screen loading (used for initial page loads)
  return (
    <div className="loading-container">
      <div className="loading-overlay">
        <div className="loading-content">
          {type === 'spinner' && (
            <div className="spinner-container">
              <div className="professional-spinner">
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-center"></div>
              </div>
            </div>
          )}

          {type === 'dots' && (
            <div className="dots-container">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          )}

          {type === 'pulse' && (
            <div className="pulse-container">
              <div className="pulse-circle"></div>
              <div className="pulse-wave"></div>
              <div className="pulse-wave"></div>
            </div>
          )}

          <div className="loading-text">
            <h3>{message}</h3>
            <div className="loading-progress">
              <div className="progress-bar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
